'use strict';

var isZeroValueString = require('../../../../../../motion-utils/dist/es/is-zero-value-string.cjs');

function isNone(value) {
    if (typeof value === "number") {
        return value === 0;
    }
    else if (value !== null) {
        return value === "none" || value === "0" || isZeroValueString.isZeroValueString(value);
    }
    else {
        return true;
    }
}

exports.isNone = isNone;
//# sourceMappingURL=is-none.cjs.map
